export default "__VITE_ASSET__Bnj9GPkr__"